import { FieldTypes } from "../fields/types";
import { Handler } from "../types/store-types";
import {
    IPayments,
    PaymentActionTypes,
    ChangeIsShowPromoCodeFieldActionType,
    ChangeIsShowPaymentTypeFieldActionType,
    InitPayableFieldsActionType,
    PaymentTypeEnum,
    InitPaymentDataActionType,
    GetSquareSubsSuccessActionType,
} from "./types";

const initPaymentData: Handler<IPayments, InitPaymentDataActionType> = (state, { payload }) => {
    setTimeout(() => {
        window.declareFields(payload);
    });
    return { ...state };
};

const changeIsFormHavePromoCodeField: Handler<IPayments, ChangeIsShowPromoCodeFieldActionType> = (
    state,
    { payload },
) => {
    return { ...state, isShowPromocodeField: payload.value };
};
const changeIsShowPaymentTypeField: Handler<IPayments, ChangeIsShowPaymentTypeFieldActionType> = (
    state,
    { payload },
) => {
    return { ...state, isShowPaymentTypeField: payload.value };
};

const initPayableFields: Handler<IPayments, InitPayableFieldsActionType> = (state, { payload }) => {
    const { list, paymentSettings } = payload;
    let isShowPaymentTypeField = false;
    let isShowPromocodeField = false;
    if (paymentSettings && paymentSettings.payableFields) {
        const {
            promocodes,
            enablePromocode = true,
            paymentMethod,
            paymentType,
            payableFields: { ONE_TIME: oneTimePayableFieldsList, SUBSCRIPTION: subscriptionPayableFieldsList },
        } = paymentSettings;
        list.forEach(field => {
            if (
                field.type === FieldTypes.PROMOCODE &&
                enablePromocode &&
                ((+paymentType === PaymentTypeEnum.ONE_TIME &&
                    oneTimePayableFieldsList &&
                    oneTimePayableFieldsList.length > 0) ||
                    (+paymentType !== PaymentTypeEnum.ONE_TIME &&
                        subscriptionPayableFieldsList &&
                        subscriptionPayableFieldsList.length > 0)) &&
                promocodes.length &&
                promocodes.some(element => element.isActive === true)
            ) {
                isShowPromocodeField = true;
            } else if (field.type === FieldTypes.PAYMENT_METHOD) {
                let activePaymentMethodsCount = 0;
                Object.values(paymentMethod).forEach(element => {
                    if (element) activePaymentMethodsCount++;
                });
                if (
                    activePaymentMethodsCount > 1 &&
                    ((+paymentType === PaymentTypeEnum.ONE_TIME &&
                        oneTimePayableFieldsList &&
                        oneTimePayableFieldsList.length > 0) ||
                        (+paymentType !== PaymentTypeEnum.ONE_TIME &&
                            subscriptionPayableFieldsList &&
                            subscriptionPayableFieldsList.length > 0))
                ) {
                    isShowPaymentTypeField = true;
                }
            }
        });
    }

    return { ...state, isShowPaymentTypeField, isShowPromocodeField };
};

const setSubscriptionPlans: Handler<IPayments, GetSquareSubsSuccessActionType> = (state, { payload }) => {
    return { ...state, subscriptionPlans: payload.data };
};

export const paymentHandlers = {
    [PaymentActionTypes.INIT_PAYMENT_DATA]: initPaymentData,
    [PaymentActionTypes.INIT_PAYABLE_FIELDS]: initPayableFields,
    [PaymentActionTypes.CHANGE_IS_SHOW_PAYMENT_TYPE_FIELD]: changeIsShowPaymentTypeField,
    [PaymentActionTypes.CHANGE_IS_SHOW_PROMOCODE_FIELD]: changeIsFormHavePromoCodeField,
    [PaymentActionTypes.GET_SQUARE_SUBSCRIPTIONS_SUCCESS]: setSubscriptionPlans,
};
